export default {
  title: 'Resultado da emissão de faturas',
  documentValidation: 'Validação do documento:',
  syntacticValidation: 'Validação sintática:',
  semanticValidation: 'Validação semântica:',
  summary: 'Resumo',
  correctBills: 'Faturas corretas',
  rejectedBills: 'Faturas rejeitadas',
  totalBills: 'Total de Faturas'
}